(() => {
  'use strict';

  const intervalMs = 100;
  const maxAttempts = 200; // 20s
  let attempts = 0;

  const timer = setInterval(() => {
    attempts += 1;

    const plugin = document.getElementById('swym-plugin');
    const anchor = plugin?.querySelector('#swym-anchor');

    if(window._swat && window._swat.fetchWishlistCount && (typeof window._swat.fetchWishlistCount === "function"))
    window._swat.fetchWishlistCount((c, e) => {
      if (e) {
        console.error('fetchWishlistCount error:', e);
        return;
      }

      const count =
        typeof c === 'number'
          ? c
          : c && typeof c === 'object'
          ? Number(c.data.count) || 0
          : 0;

      console.log('Wishlist count:', count);
      // TODO: use `count` (e.g., update UI)

      //const hearth = document.querySelector(".swym-header-launcher-count");
      //console.log(hearth);

    });

    if (plugin && anchor) {
      if (anchor.getAttribute('data-position') !== 'bottom-right') {
        anchor.setAttribute('data-position', 'bottom-right');
      }
      clearInterval(timer);
      return;
    }

    if (attempts >= maxAttempts) {
      clearInterval(timer);
    }
  }, intervalMs);


    


})();
